import React from 'react';
import { Quote, Award } from 'lucide-react';
import img from '../../assets/james_augustine.jpeg'

const FounderMessage = ({ className = "" }) => {
  // const achievements = [
  //   {
  //     icon: TrendingUp,
  //     title: "20+ Years",
  //     subtitle: "Real Estate Experience"
  //   },
  //   {
  //     icon: GraduationCap,
  //     title: "MBA Graduate",
  //     subtitle: "Pune University"
  //   },
  //   {
  //     icon: Building,
  //     title: "Full Spectrum",
  //     subtitle: "Property Development"
  //   },
  //   {
  //     icon: Award,
  //     title: "Industry Expert",
  //     subtitle: "Sustainable Development"
  //   }
  // ];

  return (
    <div className={`pt-20 sm:pt-28 ${className}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-red-50 px-6 py-3 rounded-full text-[var(--primarycolor)] text-sm font-medium mb-8">
            <Quote className="w-4 h-4" />
            A Message from Our Founder
          </div>
          
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-6 tracking-tight">
            Leadership with
            <span className="block text-[var(--primarycolor)] font-normal">Vision & Purpose</span>
          </h2>
        </div>

        {/* Main Content */}
        <div className="grid lg:grid-cols-3 gap-16 mb-16 items-stretch">
          {/* Left - Founder Profile */}
          <div className="lg:col-span-1 flex">
            <div className="bg-white rounded-2xl p-8 border border-gray-200 text-center sticky top-8 w-full h-full flex flex-col justify-center">
              <div className="w-40 rounded-full flex items-center justify-center mx-auto mb-6">
                <img src={img} alt="" className='rounded-xl ' />
              </div>
              
              <h3 className="text-2xl font-semibold text-gray-900 mb-2">James Augustine</h3>
              <p className="text-[var(--primarycolor)] font-medium">Managing Director</p>
            </div>
          </div>

          {/* Right - Biography */}
          <div className="lg:col-span-2 flex">
            <div className="bg-white rounded-2xl p-5 sm:p-8 border border-gray-200 w-full h-full flex flex-col justify-center">
              <h4 className="text-xl font-semibold text-gray-900 mb-6 flex items-center gap-3">
                <Award className="w-5 h-5 text-[var(--primarycolor)]" />
                Proven Leadership
              </h4>
              
              <div className="space-y-6 text-gray-800 leading-relaxed">
                <p>
                  With a distinguished career spanning over 20 years, James Augustine has firmly established himself as a visionary leader and seasoned expert in the real estate sector. He brings to the table a rare blend of deep industry knowledge, strategic foresight, and a passion for transforming spaces into enduring landmarks.
                </p>
                
                <div className="mt-8 pt-6 border-t border-gray-200">
                  {/* <Quote className="w-5 h-5 text-[var(--primarycolor)] mb-4" /> */}
                  <blockquote className="text-gray-800 italic leading-relaxed">
                    "Dignity is my commitment to creating an environment where seniors can live with comfort, wellness, and independence. Every detail will reflect care, dignity and excellence."
                  </blockquote>
                  <p className="mt-4 text-sm font-medium text-gray-600">— James Augustine</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Commitment Statement */}
        <div className="mt-12 text-center">
          <div className="max-w-4xl mx-auto bg-gray-50 rounded-3xl p-6 sm:p-12 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-red-500/5 rounded-full blur-2xl"></div>
            
            <div className="relative z-10">
              <h3 className="text-2xl md:text-3xl font-light text-gray-900 mb-6">
                Building Tomorrow's Legacy Today
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed">
                Under James Augustine's leadership, Whitespace Properties is committed to creating more than just retirement communities. We're building legacies of care, dignity, and excellence that will serve Kerala's seniors for generations to come.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FounderMessage;